import React from "react";
import { getAssets } from "@unisearch/helpers";
import {
  LeadSectionHero,
  LeadSectionHighlights,
  LeadSectionForm,
} from "../components";
import styles from "./template.module.scss";

export const LeadTemplateElearning = ({ pageData }) => {
  return (
    <>
      <LeadSectionHero pageData={pageData} />
      <div className={styles.description_and_form_section_wrapper}>
        {pageData && pageData?.pageContent?.featuresSection?.length > 0 && (
          <LeadSectionHighlights pageData={pageData} />
        )}
        <LeadSectionForm pageData={pageData} />
      </div>
    </>
  );
};

export default LeadTemplateElearning;
